/*
    Colors and units are defined / described in this article
    https://storebrand.invisionapp.com/dsm/storebrand/storebrand-no/folder/colors/5addb9a27b36ef0011406c51
*/
export const base = 8;
export const baseX = (times) => base * times;
export const baseXpx = (times) => `${baseX(times)}px`;
export const maxViewPortSmallMobile = baseX(40); // 320
export const maxViewPortMobile = baseX(60); // 480
export const maxViewPortTablet = baseX(96); // 768
export const maxViewPortDesktop = baseX(141); // 1128
export const abs = {
    base: baseX(1),
    small: baseX(2),
    medium: baseX(3),
    large: baseX(4),
    smallSpace: baseX(6),
    mediumSpace: baseX(8),
    largeSpace: baseX(12),
};
export const px = Object.keys(abs).reduce((acc, key) => {
    acc[key] = `${abs[key]}px`;
    return acc;
}, {});
